import { render, staticRenderFns } from "./InputText.vue?vue&type=template&id=24d04b14"
import script from "./InputText.vue?vue&type=script&lang=js"
export * from "./InputText.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/devopsfs01/workspace/dev-rca-mobile/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('24d04b14')) {
      api.createRecord('24d04b14', component.options)
    } else {
      api.reload('24d04b14', component.options)
    }
    module.hot.accept("./InputText.vue?vue&type=template&id=24d04b14", function () {
      api.rerender('24d04b14', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/basic/InputText.vue"
export default component.exports